module.exports = __webpack_public_path__ + "static/media/shareBg.84dbd43f.png";